/* Meaningwave album finder (2026-10-09)
   - Instant search across EVERY product in the collection (reads /collections/<handle>/products.json, all pages).
   - Featured artist menu: built from "... with ARTIST | ..." in titles, matched to the product tag of the same name.
     Choosing one reloads the collection with Shopify's own tag filter (?filter.p.tag=...), so cards, sorting and
     infinite scroll keep working. */
(function () {
  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9& ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function cleanTitle(t) { return (t || '').replace(/\s*\|\s*(digital album|cd|double vinyl|vinyl|cassette.*|digital bundle)\s*$/i, '').trim(); }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : '$' + n.toFixed(2); }
  function thumb(src) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_120x120_crop_center$1$2') : ''; }

  var cache = {};
  function loadAll(handle) {
    if (cache[handle]) return cache[handle];
    var out = [];
    function page(n) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          var p = j.products || [];
          out = out.concat(p);
          if (p.length === 250 && n < 8) return page(n + 1);
          return out;
        });
    }
    cache[handle] = page(1);
    cache[handle].catch(function () { delete cache[handle]; });
    return cache[handle];
  }

  function artistsFrom(products) {
    var map = {};
    products.forEach(function (p) {
      var m = (p.title || '').match(/\bwith\s+(.+?)\s*(\||$)/i);
      if (!m) return;
      m[1].split(/\s+(?:&|and|x)\s+/i).forEach(function (name) {
        var key = name.trim().toLowerCase();
        if (key && (p.tags || []).some(function (t) { return t.toLowerCase() === key; })) {
          if (!map[key]) map[key] = { tag: key, name: name.trim().replace(/\b\w/g, function (c) { return c.toUpperCase(); }), count: 0 };
        }
      });
    });
    products.forEach(function (p) {
      (p.tags || []).forEach(function (t) { var k = t.toLowerCase(); if (map[k]) map[k].count++; });
    });
    return Object.keys(map).map(function (k) { return map[k]; }).sort(function (a, b) { return a.name.localeCompare(b.name); });
  }

  function init(root) {
    if (root.hasAttribute('data-mw-ready')) return;
    root.setAttribute('data-mw-ready', '');
    var handle = root.getAttribute('data-handle');
    var url = root.getAttribute('data-url');
    var current = (root.getAttribute('data-tag') || '').toLowerCase();
    var noun = root.getAttribute('data-noun') || 'albums';
    var input = root.querySelector('[data-mw-finder-input]');
    var box = root.querySelector('[data-mw-finder-results]');
    var select = root.querySelector('[data-mw-finder-artist]');
    var items = [], active = -1, hits = [];

    loadAll(handle).then(function (products) {
      items = products.map(function (p) {
        var v = (p.variants || [])[0] || {};
        return {
          url: '/products/' + p.handle,
          title: cleanTitle(p.title),
          type: p.product_type || '',
          price: v.price,
          img: p.images && p.images[0] ? thumb(p.images[0].src) : '',
          hay: norm(p.title + ' ' + (p.tags || []).join(' ') + ' ' + (p.vendor || '') + ' ' + (p.product_type || ''))
        };
      });
      var list = artistsFrom(products);
      if (select) {
        select.innerHTML = '';
        var all = document.createElement('option');
        all.value = ''; all.textContent = 'All artists';
        select.appendChild(all);
        list.forEach(function (a) {
          var o = document.createElement('option');
          o.value = a.tag; o.textContent = a.name + ' (' + a.count + ')';
          if (a.tag === current) o.selected = true;
          select.appendChild(o);
        });
        if (!list.length) select.closest('.mw-finder__artist').hidden = true;
      }
      if (input.value.trim()) search();
    });

    if (select) select.addEventListener('change', function () {
      var params = new URLSearchParams(location.search);
      params.delete('filter.p.tag'); params.delete('page');
      if (select.value) params.set('filter.p.tag', select.value);
      var qs = params.toString();
      location.href = url + (qs ? '?' + qs : '');
    });

    function close() { box.hidden = true; active = -1; }
    function render(q) {
      box.innerHTML = '';
      if (!hits.length) {
        var e = document.createElement('div');
        e.className = 'mw-finder__empty';
        e.textContent = items.length ? 'No ' + noun + ' match "' + q + '"' : 'Loading…';
        box.appendChild(e);
      }
      hits.slice(0, 12).forEach(function (h, i) {
        var a = document.createElement('a');
        a.className = 'mw-finder__row' + (i === active ? ' is-active' : '');
        a.href = h.url; a.setAttribute('role', 'option');
        if (h.img) { var im = document.createElement('img'); im.src = h.img; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
        var t = document.createElement('div');
        var tt = document.createElement('div'); tt.className = 'mw-finder__row-title'; tt.textContent = h.title;
        var ts = document.createElement('div'); ts.className = 'mw-finder__row-sub'; ts.textContent = h.type;
        t.appendChild(tt); t.appendChild(ts); a.appendChild(t);
        var pr = document.createElement('div'); pr.className = 'mw-finder__row-price'; pr.textContent = money(h.price); a.appendChild(pr);
        box.appendChild(a);
      });
      if (hits.length > 12) {
        var more = document.createElement('div');
        more.className = 'mw-finder__all';
        more.textContent = hits.length + ' ' + noun + ' found, keep typing to narrow it down';
        box.appendChild(more);
      }
      box.hidden = false;
    }
    function search() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      var words = norm(q).split(' ').filter(Boolean);
      hits = items.filter(function (it) { return words.every(function (w) { return it.hay.indexOf(w) > -1; }); });
      active = -1;
      render(q);
    }
    input.addEventListener('input', search);
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) search(); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      var n = Math.min(hits.length, 12);
      if (e.key === 'ArrowDown') { e.preventDefault(); active = (active + 1) % n; render(input.value.trim()); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = (active - 1 + n) % n; render(input.value.trim()); }
      else if (e.key === 'Enter') { e.preventDefault(); var h = hits[active < 0 ? 0 : active]; if (h) location.href = h.url; }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  }

  /* Sticky bar: sit just under whatever header is fixed at the top of the screen (desktop sticky header slides in on scroll). */
  function headerBottom() {
    var max = 0;
    document.querySelectorAll('#header-sticky, .header-mobile, [data-sticky-header], .nov-header-sticky, #shopify-section-nov-header *').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.height < 20 || r.width < window.innerWidth * 0.5 || r.top > 1) return;
      if (r.bottom > max) max = r.bottom;
    });
    return Math.max(0, Math.round(max));
  }
  var stickyQueued = false, trackUntil = 0;
  function updateSticky() {
    stickyQueued = false;
    if (performance.now() < trackUntil) queueSticky(true); /* keep following the header while it slides in/out */
    document.querySelectorAll('[data-mw-navbar]').forEach(function (bar) {
      var top = headerBottom();
      bar.style.setProperty('--mw-sticky-top', top + 'px');
      var r = bar.getBoundingClientRect();
      bar.classList.toggle('is-stuck', r.top <= top + 1 && window.scrollY > 0 && r.top > -5);
    });
  }
  function queueSticky(fromLoop) {
    if (!fromLoop) trackUntil = performance.now() + 700;
    if (!stickyQueued) { stickyQueued = true; requestAnimationFrame(updateSticky); }
  }
  window.addEventListener('scroll', function () { queueSticky(); }, { passive: true });
  window.addEventListener('resize', function () { queueSticky(); });

  function boot() { document.querySelectorAll('[data-mw-finder]').forEach(init); queueSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  var queued = false;
  new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; boot(); }); })
    .observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
